import { Component, OnInit, ViewChild } from '@angular/core';
import { NotasContratosComponent } from '../../../modals/notas-contratos/notas-contratos.component';
import { MatDialog } from '@angular/material';;
import { Titulares, Grupos, Beneficiarios } from 'app/entities/contratos';
import { DireccionService } from 'app/services/direccion.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-contratos-registrados',
  templateUrl: './contratos-registrados.component.html',
  styleUrls: ['./contratos-registrados.component.scss']
})

export class ContratosRegistradosComponent implements OnInit {

    public notasContratos;
    public notasCartera;
    public datos;
    public tamano;

    public dataTable_options;
    public tableOpt;
    @ViewChild(DataTableDirective, {static:true})
    tabla: DataTableDirective;
    public dtTrigger: Subject<void>

  constructor(private _geo:DireccionService,private dialog:MatDialog) {
    this.dtTrigger = new Subject();
    this.dtTrigger.next();
   }

    public titulares:Array<Titulares>;
    public benficiarios:Array<Beneficiarios>;
    public grupo:Grupos;
    public radicado:string;
    coinwallet: string[] = ['Notas Contratos','Notas Cartera'];
    selectedwallet = this.coinwallet[0];

  ngOnInit() {
    this.dataTable_options = {
      scrollX: true,
      scrollY: '383px',
      responsive:true,
      scrollCollapse: true,
      Processing:true,
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      dom: 'Blfrtip',
      buttons: [
            {
              extend: 'excel',
              text: 'Excel'
            }
        ]
    };
  }

  buscarinfogrupo(Event,radicado){
    console.log(this.radicado);
        console.log(this.radicado);
        this._geo.grupoBenTitContratos(this.radicado)
                  .subscribe(response=>{
                      this.grupo = response.grupo;
                      this.titulares=response.titulares;
                      this.benficiarios = response.beneficiarios;
                });
                    console.log(this.grupo);
                    console.log(this.titulares);
                    console.log(this.benficiarios);
    }


  notasContrato(selectedwallet){
    if (selectedwallet == "Notas Contratos") {
      this.dialog.open(NotasContratosComponent,{
        data:{
          title:'Notas Contratos',
          info: this.notasContratos
        }
      })
    } else if (selectedwallet == "Notas Cartera"){
      this.dialog.open(NotasContratosComponent, {
        data: {
          title: 'Notas Cartera',
          info: this.notasCartera
        }
      })
    }
  }

}
